<template>
  <button
    :class="[
      'tw:relative tw:flex tw:items-center tw:justify-center tw:w-14 tw:h-14 tw:rounded-2xl tw:cursor-pointer tw:border-0 tw:transition-all tw:duration-300 tw:ease-out',
      isCurrent
        ? 'tw:bg-white/30 tw:scale-110 tw:shadow-[0_0_20px_rgba(255,255,255,0.4),0_0_40px_rgba(255,255,255,0.2)]'
        : isCompleted
        ? 'tw:bg-white/20 tw:scale-100 tw:shadow-[0_0_10px_rgba(255,255,255,0.2)]'
        : 'tw:bg-transparent tw:scale-90 tw:opacity-60 tw:hover:opacity-80 tw:hover:scale-95',
    ]"
    type="button"
    @click="$emit('click')"
  >
    <font-awesome-icon :icon="step.icon" :class="['tw:text-2xl tw:text-white', isCurrent ? 'tw:drop-shadow-lg' : '']" />
    <span
      v-if="isCompleted"
      class="tw:absolute tw:-bottom-1 tw:-right-1 tw:w-5 tw:h-5 tw:bg-green-500 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:shadow-md tw:motion-preset-pop"
    >
      <font-awesome-icon icon="fa-solid fa-check" class="tw:text-white tw:text-xs" />
    </span>
    <span
      v-if="isCurrent"
      class="tw:absolute tw:inset-0 tw:rounded-2xl tw:border-2 tw:border-white/50 tw:motion-preset-pulse tw:motion-duration-2000"
    />
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { TourStep } from "./TourSlider.constants";

const props = defineProps<{
  step: TourStep;
  index: number;
  currentStepIndex: number;
}>();

defineEmits<{
  (e: "click"): void;
}>();

const isCurrent = computed(() => props.index === props.currentStepIndex);
const isCompleted = computed(() => props.index < props.currentStepIndex);
</script>
